export enum CampaignActionTypes {
  CREATE_CAMPAIGN = 'CREATE_CAMPAIGN'
}
